import type { DropdownOption } from '@x7web/tcom-ui'
import { usePreferredLanguages } from '@vueuse/core'
import { langModuleNameMap, langCodeTransMap } from '@/format/lang'

const LANGUAGE_KEY = 'new-open-platform-language' // 语言存储key;

const langModules = import.meta.glob('../../_locales/*.json', { eager: true }) // 语言文件
const compLangModules = import.meta.glob('./compnentsLocale/*.ts', { eager: true }) // 组件自定义的国际化文件

const langModuleMap = new Map<string, any>() // 语言模块映射表
const compLangModuleMap = new Map<string, any>() // 组件自定义的国际化模块映射表
const langCodeList: Array<string> = [] // 语言code列表

/** 当前需要的语言环境code列表 */
const curRequiredLangCodeList = computed<string[]>(() => langCodeList.filter((lang) => lang === 'en' || lang === 'tw'))

/** 获取默认语言环境 */
const getDefaultLanguage = () => {
  // 如果不是国际化环境，则默认为cn
  if (!window.isInternational) return 'cn'

  const languages = usePreferredLanguages()
  // 如果默认的语言环境不在curRequiredLangList中，则默认为系统语言。
  if (!unref(curRequiredLangCodeList).includes(unref(languages)[0])) return 'en'
  return langCodeTransMap[unref(languages)[0]]
}

/**
 * 生成语言模块映射表
 */
const generateLangModuleMap = () => {
  const fullPaths = Object.keys(langModules)
  fullPaths.forEach((fullPath) => {
    const k = fullPath.replace('../../_locales', '')
    const startIndex = 1
    const lastIndex = k.lastIndexOf('.json')
    const code = k.slice(startIndex, lastIndex)
    langCodeList.push(code)
    langModuleMap.set(code, langModules[fullPath])
  })
}

/**
 * 生成组件自定义的国际化模块映射表
 */
const generateCompLangModuleMap = () => {
  const fullPaths = Object.keys(compLangModules)
  fullPaths.forEach((fullPath) => {
    const k = fullPath.replace('./compnentsLocale', '')
    const startIndex = 1
    const lastIndex = k.lastIndexOf('.ts')
    const code = k.slice(startIndex, lastIndex)
    compLangModuleMap.set(code, compLangModules[fullPath])
  })
}
generateCompLangModuleMap()

/** 语言列表 */
const langList = computed(() => {
  if (langModuleMap.size === 0) generateLangModuleMap()

  const list: DropdownOption[] = []
  langModuleMap.forEach((_value, key) => {
    list.push({ content: langModuleNameMap[key], value: key })
  })
  return list
})

export { LANGUAGE_KEY, getDefaultLanguage, langCodeList, langList, curRequiredLangCodeList, compLangModuleMap }
